import styled from 'styled-components';

const HeroStyle = styled.section`
	--sizeHeroImage: 43.2%;
	--distanceNavigationInfo: var(--sp30x);
	--navigationDistance: var(--sp12x);
	--distanceNavPanel: var(--sp3x);
	--sizeIcon: var(--sp6x);
	--sizeBurgerMenuDistanceTop: var(--sp6x);

	--distanceTitleDescription: var(--sp4x);
	--distanceDescriptionButton: var(--sp6x);

	--fullHeight: 100vh;

	position: relative;

	cursor: grab;

	.line-clamp-4 {
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.info-wrapper {
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 2;
		width: 100%;
		display: flex;
		flex-direction: column;
		/* justify-content: flex-end; */
		/* margin-bottom: calc(var(--navigationDistance) + var(--distanceNavigationInfo) + var(--sizeIcon)); */

		height: 100%;
		justify-content: center;

		.inner-text-link {
			display: flex;
			flex-direction: column;
		}

		.title-animation {
			margin-bottom: var(--distanceTitleDescription);
		}

		.description-animation {
			margin-bottom: var(--distanceDescriptionButton);
		}
	}

	.navigation-wrapper {
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 90;
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding: 0 var(--contPaddingLR);
		margin-bottom: var(--navigationDistance);
		margin-top: var(--distanceNavigationInfo);

		.panel-listed {
			display: flex;
			gap: var(--distanceNavPanel);

			i {
				will-change: transform;
				transition: 0.3s ease-out;
				font-size: var(--sizeIcon);
			}
		}
	}

	.wrapper-image-info {
		position: relative;
	}

	.wrapper-button-block {
		width: fit-content;
		will-change: transform;
		/* transition: opacity 1s ease-out; */

		.wrapper-button {
			transform: translateX(calc(-1 * (100% + var(--contPaddingLR))));
		}
	}

	.item-wrapper {
		position: absolute;
		top: 0;
		width: 100%;
	}

	.first-wrapper-image {
		position: relative;
	}

	.image-wrapper {
		position: relative;
		opacity: 0;
		transition: opacity 0.6s ease-out;

		&::before {
			content: '';
			z-index: 1;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: var(--backgroundColor);
			opacity: 0.25;
		}

		.image-cont,
		.video-cont {
			--fileHeight: fit-content;
			height: calc(
				var(--fullHeight) - var(--headerFixedHeight) - var(--headerBannerHeight) - var(--distanceHero) - var(--iconSizeHero) - var(--sizeBurgerMenuDistanceTop) - var(--burgerMenuPaddingBottom) -
					var(--burgerMenuButtonHeight)
			);
		}
	}

	.first-active {
		transition: opacity 0s;
		opacity: 1;
	}

	.active {
		opacity: 1;
	}

	.other-hidden-wrapper {
		position: absolute;
		left: 0;
		background-color: var(--backgroundColor);
		z-index: 100000;
		height: 100%;
	}

	&.one-version {
		cursor: default;

		.navigation-wrapper {
			display: none;
			pointer-events: none;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.navigation-wrapper {
				.panel-listed {
					i {
						&:hover {
							transform: scale(1.2);
						}
					}
				}
			}
		}
	}

	.link-item {
		position: relative;
		overflow: hidden;
	}

	a.link-item::before {
		content: '';
		position: absolute;
		inset: -6px;
		background-color: var(--backgroundColor);
		z-index: -1;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeHeroImage: 35%;
		--distanceNavigationInfo: var(--sp9x);
		--navigationDistance: var(--sp7x);
		--distanceNavPanel: var(--sp2x);
		--sizeIcon: var(--sp4x);
		--sizeBurgerMenuDistanceTop: var(--sp3x);
		--distanceTitleDescription: var(--sp3x);
		--distanceDescriptionButton: var(--sp5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeHeroImage: 38%;
		--distanceNavigationInfo: var(--sp10x);
		--navigationDistance: var(--sp6x);
		--sizeBurgerMenuDistanceTop: var(--sp1-5x);
		--distanceTitleDescription: var(--sp2-5x);
		--distanceDescriptionButton: var(--sp6x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--navigationDistance: var(--sp4x);
		--sizeBurgerMenuDistanceTop: var(--sp3x);
		--distanceTitleDescription: var(--sp2x);
		--distanceDescriptionButton: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceNavigationInfo: var(--sp9x);
		--navigationDistance: var(--sp5x);
		--sizeBurgerMenuDistanceTop: var(--sp1x);

		--fullHeight: 100svh;

		--distanceTitleDescription: var(--sp1-5x);
		--distanceDescriptionButton: var(--sp4x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeHeroImage: 100%;
		--distanceNavigationInfo: var(--sp10x);
		--navigationDistance: var(--sp6x);
		--sizeIcon: var(--sp3x);
		--sizeBurgerMenuDistanceTop: var(--sp4x);

		--distanceTitleDescription: var(--sp1x);
		--distanceDescriptionButton: var(--sp4x);

		/* At this width the delivery bar switches to a full-width, stacked
		 * (tabs + selector) layout and grows taller. On short viewports the
		 * calculated image height can end up shorter than that, so the
		 * vertically-centered title/button block collides with it. Floor the
		 * image height so there's always enough room for both. */
		.image-wrapper {
			.image-cont,
			.video-cont {
				min-height: 430px;
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeHeroImage: 165%;
		--distanceNavigationInfo: var(--sp9x);
		--navigationDistance: var(--sp4x);
		--sizeBurgerMenuDistanceTop: var(--sp3x);

		--distanceTitleDescription: var(--sp2x);
		--distanceDescriptionButton: var(--sp3x);
	}
`;

export default HeroStyle;
